import { render, staticRenderFns } from "./fun.vue?vue&type=template&id=fc1d2212&"
import script from "./fun.vue?vue&type=script&lang=ts&"
export * from "./fun.vue?vue&type=script&lang=ts&"
import style0 from "./fun.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports